var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C6.71561 0 0 4.68103 0 10.4556C0 13.2822 1.6118 15.845 4.22678 17.727L4.23101 24L12.0704 20.7106C13.0182 20.8412 13.9971 20.9112 15 20.9112C23.2844 20.9112 30 16.2299 30 10.4556C30 4.68103 23.2844 0 15 0ZM8.6853 12.6525C7.51927 12.6525 6.57388 11.7781 6.57388 10.6997C6.57388 9.62129 7.51927 8.74693 8.6853 8.74693C9.85132 8.74693 10.7967 9.62129 10.7967 10.6997C10.7967 11.7781 9.85132 12.6525 8.6853 12.6525ZM14.9926 12.6525C13.8266 12.6525 12.8812 11.7781 12.8812 10.6997C12.8812 9.62129 13.8266 8.74693 14.9926 8.74693C16.1586 8.74693 17.104 9.62129 17.104 10.6997C17.1043 11.7781 16.1589 12.6525 14.9926 12.6525ZM21.2134 12.6525C20.0471 12.6525 19.1019 11.7781 19.1019 10.6997C19.1019 9.62129 20.0471 8.74693 21.2134 8.74693C22.3797 8.74693 23.3248 9.62129 23.3248 10.6997C23.3248 11.7781 22.3797 12.6525 21.2134 12.6525Z",
    fill: "#818090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/ChatIcon.aba4cf0e29a279243b6e7e5498526fe4.svg";
export { ForwardRef as ReactComponent };